import { render, staticRenderFns } from "./AssetsListRightPopup.vue?vue&type=template&id=2d65b1fa&scoped=true"
import script from "./AssetsListRightPopup.vue?vue&type=script&lang=js"
export * from "./AssetsListRightPopup.vue?vue&type=script&lang=js"
import style0 from "./AssetsListRightPopup.vue?vue&type=style&index=0&id=2d65b1fa&prod&lang=scss&scoped=true"
import style1 from "./AssetsListRightPopup.vue?vue&type=style&index=1&id=2d65b1fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65b1fa",
  null
  
)

export default component.exports